// useResponsiveLayout.js
import { useState, useEffect } from "react";

const useResponsiveLayout = () => {
  const [gridRows, setGridRows] = useState(getGridTemplateRows());
  const [orientation, setOrientation] = useState(window.innerHeight > window.innerWidth ? "portrait" : "landscape");

  function getGridTemplateRows() {
    const { innerWidth: width, innerHeight: height } = window;
    const isPortrait = height > width;
    if (!isPortrait) {
      return height >= 1080 ? "120px 300px 3fr 3fr 150px" : "120px 300px 3fr 2.5fr 150px";
    } else {
      return height >= 1920 ? "120px 300px 3fr 3fr 150px" : "120px 300px 3fr 2.5fr 150px";
    }
  }

  function getResponsiveMargin() {
    const { innerWidth: width, innerHeight: height } = window;
    const isLandscape = width > height;
    const isFullHDOrMore = width >= 1920;
    if (isLandscape && isFullHDOrMore) return "10px 0 0 0";
    if (isLandscape && !isFullHDOrMore) return "0px 0 0px 0";
    if (!isLandscape && isFullHDOrMore) return "0px 0 0 20px";
    return "40px 0 0 0";
  }

  useEffect(() => {
    const updateLayout = () => {
      setGridRows(getGridTemplateRows());
      setOrientation(window.innerHeight > window.innerWidth ? "portrait" : "landscape");
    };
    window.addEventListener("resize", updateLayout);
    window.addEventListener("orientationchange", updateLayout);
    return () => {
      window.removeEventListener("resize", updateLayout);
      window.removeEventListener("orientationchange", updateLayout);
    };
  }, []);

  return { gridRows, orientation, getResponsiveMargin };
};

export default useResponsiveLayout;
